<template>
	<div> 
		<v-dialog 
			v-model="deals"
			hide-overlay
			width="40%"
			transition="slide-x-reverse-transition"
			content-class="interested rounded-tl-0 rounded-tr-0 rounded-br-0 rounded-bl-xl">
			<ManageListings 
				@viewDealDetails="dealDetails = !dealDetails" 
				@closeDeals="deals = !deals" 
				@manageId="setManageId" 
				:reloadListings="hilight" />
		</v-dialog>

		<v-navigation-drawer 
			v-if="manageId != ''" 
			v-model="dealDetails" 
			absolute 
			temporary 
			right
			hide-overlay 
			dark 
			width="100%" 
			color="#FFF">
			<ManageDeals 
				:listingId="manageId" 
				:key="manageId"
				@closeDetails="dealDetails = !dealDetails" 
				@quickViewDeals="deals = !deals" />
		</v-navigation-drawer>

		<v-app-bar color="primary darken-2" elevation="2" app>
			<div class="d-flex align-center container_width center_header">
				<a href="https://www.successionresource.com" target="_blank">
					<v-img :src="logo_img" width="130" class="mr-1" atl="Succession Resource Group"></v-img>
				</a>

				<v-toolbar
					variant="vertical"
					color="primary darken-2"
					class="d-inline"
					flat>
				
					<v-toolbar-items class="py-0">
						<v-btn v-if="isClient" text color="#EFEFEF" to="/dashboard">
							<v-icon left class="mr-3">mdi-home</v-icon>
							<span class="button_text text-capitalize text_condensed">{{ authUser.group === 'partner_admin' ? 'Partner Dashboard' : 'My Projects' }}</span>
						</v-btn>

						<v-divider v-if="isClient && !authUser.is_secondary" 
							vertical 
							color="#0A5B64">
						</v-divider>

						<v-btn v-if="hasProfile"
							text 
							color="#EFEFEF" 
							to="/buyer_listings">
							<v-icon left class="mr-3">{{ isClient ? 'mdi-playlist-check' : 'mdi-home' }}</v-icon>
							<span class="button_text text-capitalize text_condensed">Seller Listings</span>
						</v-btn>

						<!-- <v-divider vertical color="#0A5B64"></v-divider>

						<v-btn text color="#EFEFEF" to="/benchmarking">
							<v-icon left class="mr-3">mdi-chart-pie</v-icon>
							<span class="button_text text-capitalize text_condensed">Benchmarking</span>
						</v-btn> -->

						<v-divider vertical color="#0A5B64"></v-divider>

						<v-btn text color="#EFEFEF" to="/services">
							<v-icon left class="mr-3">mdi-apps</v-icon>
							<span class="button_text text-capitalize text_condensed">Services</span>
						</v-btn>
					</v-toolbar-items>
				</v-toolbar>

				<v-spacer></v-spacer>

				<!-- <v-divider vertical color="#EFEFEF" class="mr-10 my-1"></v-divider> -->
				<div class="d-flex d-inline">
					<v-menu 
						open-on-hover 
						bottom 
						left
						offset-y 
						origin="top right" 
						transition="scale-transition">

						<template v-slot:activator="{ on }">
							<div class="text-center d-inline">
								<div class="d-block">
									<v-btn 
										v-on="on"
										small
										icon
										color="white">
										<v-icon large class="font-weight-thin">mdi-account-circle-outline</v-icon>
									</v-btn>
								</div>
								<div v-on="on" class="d-block white--text text-capitalize font-weight-thin mt-1" style="font-size:.8em">{{ user_firstname }}</div>
							</div>
							<div class="d-inline d-flex align-center ml-1">
								<v-icon v-on="on" small class="white--text">mdi-chevron-down</v-icon>
							</div>
						</template>

						<v-list class="rounded">
							<v-list-item to="/account" push class="user_menu justify-center">Account</v-list-item>
							<!-- <v-list-item @click="openPanel" class="user_menu justify-center">Listing Status</v-list-item> -->
							<v-list-item @click="logOut()" class="user_menu justify-center">Logout</v-list-item>
						</v-list>
					</v-menu>
				</div>
			</div>

		</v-app-bar>      
	</div>
</template>

<script>
	import axios from "axios";
	import Cookie from 'js-cookie';
	import appUrls from '../helpers/environment';

	import logo_img from '../assets/SRGLogo_white_2022.svg';

	import ManageListings from './ManageListings'
	import ManageDeals from './ManageDeals'

	export default {
    	name: 'Header',

    	components: {
        	ManageDeals,
        	ManageListings,
    	},
    
		props: {
            viewDeals: Boolean
		},

		data() {
    		return {
				isClient: Boolean,
				hasProfile: Boolean,
				//authenticated: true,
				advisor_welcome: '',
				user_firstname: '',
				logo_img: logo_img,
				hilight: false,
				deals: false,
				dealDetails: false,
				manageId: '',
				authUser: {
					id: String,
					group: String,
					is_secondary: Boolean
				}
			}
    	},

		watch: {
			viewDeals (val) {
				this.deals = true
				this.hilight = !this.hilight
			}
		},
		
		created () {
        	this.checkUser()
        },

		mounted () {
			this.setUserInfo();
		},

		methods: {
			checkUser: async function () {
				await axios.get(`${appUrls.api}/api/user_check`, {
                    headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" }
                })
                .then( res => {
                    if(res.data.outcome) {    
						this.authUser.id = res.data.user_data.id
						this.authUser.group = res.data.user_data.group
						this.authUser.is_secondary = res.data.user_data.is_secondary
                    } else {
						console.log(res.data.message)
					}
                })
                .catch(function (error) {
                    console.log(error);
                });
			},

			setUserInfo: async function () {
				//this.authenticated = Cookie.get('token') ? true : false;
				let name = Cookie.get('name') ? Cookie.get('name').split(' ') : '';
				this.advisor_welcome = name != '' ? name[0][0]+name[1][0] : '';
				this.user_firstname = name != '' ? name[0] : '';
				this.isClient = Cookie.get('is_client') === 'true' ? true : false;
				this.hasProfile = Cookie.get('has_profile') === 'true' ? true : false;
			},

			// getUserDetails() {
			// 	// get token from localstorage
			// 	let token = localStorage.getItem("user");
			// 	try {
			// 	//decode token here and attach to the user object
			// 	let decoded = VueJwtDecode.decode(token);
			// 	this.isClient = decoded.is_client === 'true' ? true : false;
			// 	} catch (error) {
			// 		// return error in production env
			// 		console.log(error, 'error from decoding token')
			// 	}
			// },
		
			logOut() {
				Cookie.remove('token')
				Cookie.remove('is_client')
				Cookie.remove('has_profile')
				Cookie.remove('name')
				Cookie.remove('id')
				Cookie.remove('sugar')

				this.$emit('logoutDialog', false)
				this.$emit('authenticated', false)
			
				clearInterval(this.timer)
				clearTimeout(this.logoutTimer)
				this.$emit('timer', null)
				this.$emit('progressValue', 0)
				this.$emit('stopped', false)

				this.$router.replace({ name: 'login' }).catch(err => {})
			},

			setManageId: function(val) {
				this.manageId = val
			},
		}
	}
</script>

<style scoped>
	>>> .interested {
		/* align-self: flex-start;  */
		/* .v-dialog:not(.v-dialog--fullscreen) */
		top: 0 !important;
		right: 0 !important;
		position: absolute !important;
		margin: 65px 0 0 0;
		padding: 0;
	}

	.center_header {
    	margin: 0 auto;
  	}
</style>


// WEBPACK FOOTER //
// src/components/Header.vue